import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip'
import type { ReactElement, ReactNode } from 'react'
import { cn } from '../lib/cn'
import type { Hotkey } from '../lib/hotkeys'
import { useLayer, Z } from './context'
import { Kbd } from './Kbd'

export interface TooltipProps {
  /** Text des Tooltips; leer → es wird nur das Kind gerendert */
  content?: ReactNode
  /** erscheint hinter dem Text */
  hotkey?: Hotkey
  side?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  /** ms bis zum Erscheinen per Zeiger; bei Tastaturfokus sofort. Standard 400 */
  delay?: number
  /** genau ein Element, das Ref und Ereignisse annimmt */
  children: ReactElement<Record<string, unknown>>
  className?: string
}

/** Kurzer Hinweis zu einem Bedienelement. Fläche `inverse`, erscheint nach 400 ms. */
export function Tooltip({ content, hotkey, side = 'top', align = 'center', delay, children, className }: TooltipProps) {
  const zIndex = useLayer(Z.popover)
  if (content === undefined || content === null || content === '' || content === false) return children
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} delay={delay} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} align={align} sideOffset={6} style={{ zIndex: `calc(${zIndex} + 2)` }}>
          <BaseTooltip.Popup
            className={cn(
              'flex max-w-72 items-center gap-2 rounded-sm bg-inverse px-2 py-1 text-caption font-medium text-fg-inverse shadow-md',
              'origin-(--transform-origin) transition-[opacity,scale] duration-(--duration-fast) ease-snap',
              'data-starting-style:scale-98 data-starting-style:opacity-0 data-ending-style:opacity-0',
              className,
            )}
          >
            {content}
            {hotkey && <Kbd hotkey={hotkey} variant="plain" />}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  )
}
